import styled from 'styled-components';
import { space, layout, typography, SpaceProps, LayoutProps, TypographyProps } from 'styled-system';
import { Container } from './container.style';

interface StyleProps extends SpaceProps, LayoutProps, TypographyProps {}

export const OneColumnGrid = styled(Container)<StyleProps>`
  margin: 0;
  padding: 0 24px 48px;
  width: 100%;
  ${space} ${layout} ${typography} button {
    width: 100%;
  }

  ${props => props.theme.media.tabletPortraitUp} {
    margin: 0 auto;
    max-width: 480px;
    padding: 75px 0;
  }

  ${props => props.theme.media.largeScreenUp} {
    max-width: 600px;
  }
`;
